import * as React from 'react';

const styles = require('./MailListItem.scss');

export default function renderMeetingInfoPlaceHolder(): JSX.Element {
    return <div className={styles.meetingInfoSingleLine} />;
}
